import PopularSearchesBlock from './popularSearchesBlock'

export default PopularSearchesBlock
